interface ThanksData {
  title: string;
  links: ThanksLinkData[];
}

export interface ThanksLinkData {
  text: string;
  linkText: string;
  linkHref: string;
}

export const thanks: ThanksData = {
  title: 'Thanks for your RSVP',
  links: [
    {
      text: 'If you have any questions, hopefully we have the ',
      linkText: 'answers.',
      linkHref: '/questions',
    },
    {
      text: 'If you like buying gifts, check out our ',
      linkText: 'registry!',
      linkHref: '/registry',
    },
  ],
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/data/thanks.ts